import InvoiceIcon from '@material-ui/icons/LibraryBooks';
import FileBlockingList from './FileBlockingList';

const fileBlocking = {
    list: FileBlockingList,
    icon: InvoiceIcon,
};

export default fileBlocking;